export const messagesProf = [
  {
    to: "Parents de Lucas Bernard",
    date: "2025-09-12",
    sujet: "Travail non rendu",
    contenu: "Bonjour, Lucas n’a pas rendu le devoir d’histoire demandé. Merci de le rappeler à l’ordre."
  },
  {
    to: "Emma Petit",
    date: "2025-09-11",
    sujet: "Félicitations",
    contenu: "Très bon devoir de mathématiques, continue comme ça."
  },
  {
    to: "Direction",
    date: "2025-09-10",
    sujet: "Demande de matériel",
    contenu: "Serait-il possible de renouveler le stock de feuilles pour la salle B203 ?"
  }
];